import type { Country } from "react-phone-number-input";

export const AU_COUNTRY: Country = "AU";
export const AU_CALLING_CODE = "+61";
export const AU_DOMESTIC_PREFIX = "0";
export const AU_MOBILE_PREFIX = "4";
export const NP_CALLING_CODE = "+977";
export const NP_DOMESTIC_PREFIX = "9";
